import { t } from "@/i18n-js/instance";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { Lines } from "../Lines";

export const RegularPriceLine = ({
  preview,
}: Pick<ComponentLineProps, "preview">) => (
  <Lines.RegularPriceLine
    preview={preview}
    options={{ label: t("subtotal") }}
  />
);
